import React, { ReactNode } from 'react';
import { AnalyticsContext } from '../context/AnalyticsContext';
import { AnalyticsManager } from '../AnalyticsManager';

interface AnalyticsProviderProps {
    analytics: AnalyticsManager;
    children: ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ analytics, children }) => {
    return <AnalyticsContext value={{ analytics }}>{children}</AnalyticsContext>;
};
